import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"

import type { CommonService } from "./service"

export type ListServicesResponseItem = CommonService

export type ListServicesQuery = {
  search?: string
}

export const listServices = async (
  query?: ListServicesQuery
) => {
  const { body } = await api.get<
    ListServicesResponseItem[]
  >("/beepaidgo/services/", { query: query })
  return body
}

export const useServices = (
  query?: MaybeRef<ListServicesQuery | undefined>
) =>
  useQuery({
    queryKey: [SERVICES_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listServices(query_),
  })
